import * as React from 'react';
import { cn } from '@/lib/utils';

export interface WizardStepPanelProps {
  children: React.ReactNode;
  /** Optional className to merge with the default scrollable panel classes. */
  className?: string;
}

/**
 * Thin right-side content slot for the wizard shell.
 *
 * Provides a vertically scrollable flex-1 region that hosts either:
 * - the currently-active step (single-view mode), or
 * - all steps rendered vertically (expand-all mode).
 *
 * Kept intentionally minimal so hosts can style content via the children they pass in.
 */
export function WizardStepPanel({ children, className }: WizardStepPanelProps) {
  return (
    <div className={cn('flex-1 min-h-0 overflow-y-auto px-6 py-6', className)}>
      {children}
    </div>
  );
}

export default WizardStepPanel;
